import { ChangeEvent, FunctionComponent, useCallback, useState } from 'react';
import { Trans } from 'react-i18next';

import ExinMuiRadioGroup from '../styled/ExinMuiRadioGroup';

export enum TrainingCompletedOption {
  YES = 'TRAINING_COMPLETE_YES',
  NO = 'TRAINING_COMPLETE_NO',
}

const OPTIONS = [
  {
    label: <Trans i18nKey="trainingCompletedYesLabel">Yes, I've completed the training</Trans>,
    value: TrainingCompletedOption.YES,
  },
  {
    label: <Trans i18nKey="trainingCompletedNoLabel">No, I've not completed the training</Trans>,
    value: TrainingCompletedOption.NO,
  },
];

const StepTrainingCompleteChoice: FunctionComponent<{
  onChange(value: TrainingCompletedOption): void;
}> = ({ onChange }) => {
  const [selected, setSelected] = useState<null | TrainingCompletedOption>(null);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value as TrainingCompletedOption;
      setSelected(value);
      onChange(value);
    },
    [onChange]
  );

  return (
    <div>
      <ExinMuiRadioGroup value={selected} onChange={handleChange} options={OPTIONS} />
      {selected === TrainingCompletedOption.NO && (
        <p>
          <Trans i18nKey="trainingRequiredMessage">
            Training is required for this certification.
          </Trans>
        </p>
      )}
    </div>
  );
};

export default StepTrainingCompleteChoice;
